import React from 'react';
import PropTypes from 'prop-types';
import CheckIcon from 'react-material-icons/icons/action/check-circle';
import csCanceledIcon from '@chama/statics/assets/svg/cs-canceled-icon.svg';
import dealerCanceledIcon from '@chama/statics/assets/svg/dealer-cancelled-icon.svg';
import consumerCanceledIcon from '@chama/statics/assets/svg/consumer-canceled-icon.svg';
import {
  ORDER_STATUS_DEALER_CANCELLED,
  ORDER_STATUS_DEALER_DECLINED,
  ORDER_STATUS_DEALER_DELIVERED,
  ORDER_STATUS_CONSUMER_CANCELLED,
} from '@chama/utils/constants/status';
import Tooltip from '../Tooltip';
import './index.css';

const propTypes = {
  orderStatus: PropTypes.string.isRequired,
  isCsUser: PropTypes.bool.isRequired,
  consumerDelivered: PropTypes.bool,
};

const defaultProps = {
  consumerDelivered: false,
};

const OrderStatusIcon = ({ orderStatus, consumerDelivered, isCsUser }) => {
  if (consumerDelivered) {
    const tooltipStatus = <strong>Entrega confirmada pelo cliente</strong>;

    return (
      <div className="OrderStatusIcon__icon OrderStatusIcon__icon--mui">
        <Tooltip position="right" html={tooltipStatus}>
          <CheckIcon />
        </Tooltip>
      </div>
    );
  }

  if (orderStatus === ORDER_STATUS_DEALER_DELIVERED) {
    const tooltipStatus = <strong>Entregue com sucesso</strong>;

    return (
      <div className="OrderStatusIcon__icon OrderStatusIcon__icon--mui">
        <Tooltip position="bottom" html={tooltipStatus}>
          <CheckIcon />
        </Tooltip>
      </div>
    );
  }

  const cancelledByDealer =
    orderStatus === ORDER_STATUS_DEALER_CANCELLED || orderStatus === ORDER_STATUS_DEALER_DECLINED;

  if (cancelledByDealer && !isCsUser) {
    let tooltipStatus = <strong>Cancelado pelo revendedor</strong>;

    if (orderStatus === ORDER_STATUS_DEALER_DECLINED) {
      tooltipStatus = <strong>Recusado pelo revendedor</strong>;
    }

    return (
      <div className="OrderStatusIcon__icon OrderStatusIcon__icon--full_opacity OrderStatusIcon__icon--adjusted">
        <Tooltip position="bottom" html={tooltipStatus}>
          <img src={dealerCanceledIcon} alt="dealer canceled" />
        </Tooltip>
      </div>
    );
  }

  if (cancelledByDealer && isCsUser) {
    let tooltipStatus = <strong>Cancelado pela equipe do Chama</strong>;

    if (orderStatus === ORDER_STATUS_DEALER_DECLINED) {
      tooltipStatus = <strong>Recusado pela equipe do Chama</strong>;
    }

    return (
      <div className="OrderStatusIcon__icon OrderStatusIcon__icon--full_opacity">
        <Tooltip position="bottom" html={tooltipStatus}>
          <img src={csCanceledIcon} alt="dealer canceled" />
        </Tooltip>
      </div>
    );
  }

  if (orderStatus === ORDER_STATUS_CONSUMER_CANCELLED) {
    const tooltipStatus = <strong>Cancelado pelo cliente</strong>;

    return (
      <div className="OrderStatusIcon__icon OrderStatusIcon__icon--full_opacity">
        <Tooltip position="bottom" html={tooltipStatus}>
          <img src={consumerCanceledIcon} alt="consumer canceled" />
        </Tooltip>
      </div>
    );
  }

  return null;
};

OrderStatusIcon.propTypes = propTypes;
OrderStatusIcon.defaultProps = defaultProps;

export default OrderStatusIcon;



// WEBPACK FOOTER //
// ../ui-components/components/OrderStatusIcon/index.jsx